import React, { useMemo } from 'react'
import DropDown from '../dropdown';
import PropTypes from "prop-types";
import { Wings } from '../../../api/services/next';

const WingDropDown = ({HotelID, data, ...rest}) => {
    const spec = useMemo(() => ({ HotelId: HotelID }), [HotelID]);
    return <DropDown search api={data ? undefined : Wings.GetWings} spec={data ? undefined : spec} textField="Name" valueField="Id" data={data} {...rest} />
}

WingDropDown.propTypes = {
    HotelID: PropTypes.any,
    data: PropTypes.array,
}
export default WingDropDown
